export enum PageTitle {
  Hub = "ADMIN_PORTAL.NAVIGATION.HUB",
  Login = "ADMIN_PORTAL.NAVIGATION.LOGIN",
  Register = "ADMIN_PORTAL.NAVIGATION.REGISTER",
  ForgotPassword = "ADMIN_PORTAL.NAVIGATION.FORGOT_PASSWORD",
  ResetPassword = "ADMIN_PORTAL.NAVIGATION.RESET_PASSWORD",
  DuplicateSession = "ADMIN_PORTAL.NAVIGATION.DUPLICATE_SESSION",
  Dashboard = "ADMIN_PORTAL.NAVIGATION.DASHBOARD",
  Equipment = "ADMIN_PORTAL.NAVIGATION.EQUIPMENT",
  Agents = "ADMIN_PORTAL.NAVIGATION.AGENTS",
  TrainingDocumentation = "ADMIN_PORTAL.NAVIGATION.TRAINING_DOCUMENTATION",
  Invoices = "ADMIN_PORTAL.NAVIGATION.INVOICES",
  Profile = "ADMIN_PORTAL.NAVIGATION.PROFILE",
  Accounts = "ADMIN_PORTAL.NAVIGATION.ACCOUNTS",
  Settings = "ADMIN_PORTAL.NAVIGATION.SETTINGS",
}
